import React from 'react'
import { useParams } from 'react-router-dom'
import CollectionService from '../../service/CollectionService'
import Collection, { CollectionRetrieve } from '../../domain/Collection'
import { statusLabel } from '../../domain/Status'
import useEntity from '../../hooks/useEntity'
import { paths } from '../../routes'
import FindBox from '../ui/FindBox'
import EntityState from '../ui/EntityState'
import EntitySummary from '../ui/EntitySummary'
import StatusChanger from '../ui/StatusChanger'

const CollectionUpdateForm: React.FC = () => {
    const { id } = useParams()
    const {
        entity: collection,
        setEntity,
        loading,
        error,
        find,
        refresh,
    } = useEntity<CollectionRetrieve>({
        kind: 'collection',
        id,
        retrieve: (collectionId) => CollectionService.retrieve(collectionId),
        pathFor: paths.collection.update,
        notFound: 'Collection not found. Check the ID and try again.',
        remember: (found) => ({ label: found.reference, accountId: found.accountId }),
    })

    const changeStatus = (status: string) => {
        const { id: collectionId, accountId, collectionAccountId } = collection as CollectionRetrieve
        return CollectionService.update(collectionId, { status, accountId, collectionAccountId }).then(() => setEntity((current) => current && { ...current, status }))
    }

    return (
        <div className="stack">
            <FindBox kind="collection" title="Find a Collection" placeholder="Enter Collection ID" value={id} loading={loading} onFind={find} />
            <EntityState id={id} loading={loading} error={error} ready={!!collection} emptyText="Enter a Collection ID above, or pick a recent one.">
                {collection && (
                    <>
                        <EntitySummary
                            title="Collection Information"
                            status={collection.status}
                            statusLabel={statusLabel(collection.status, Collection.statuses(collection))}
                            items={[
                                { label: 'Collection ID', copy: collection.id },
                                { label: 'Wallex reference', copy: collection.reference },
                                { label: 'Account ID', copy: collection.accountId },
                                { label: 'Collection account ID', copy: collection.collectionAccountId },
                            ]}
                            refreshing={loading}
                            onRefresh={refresh}
                        />
                        <StatusChanger
                            noun="collection"
                            current={collection.status}
                            statuses={Collection.statuses(collection)}
                            journey={Collection.journey}
                            hints={Collection.hints}
                            onSubmit={changeStatus}
                        />
                    </>
                )}
            </EntityState>
        </div>
    )
}

export default CollectionUpdateForm
